// Wallet buttons in the PaymentElement are opt-in: the safe default is off,
// because some card forms render for practice staff, where the wallet sheet
// offers the staff member's own Apple Pay / Google Pay card, not the client's.
export const WALLETS_NEVER = { applePay: 'never', googlePay: 'never' };

// Client-facing surfaces opt in through the public wallet_payments_enabled
// flag (ENG-19206). PaymentElement shows wallets by default when the option is
// omitted, so every call site must pass one of these.
export function walletsForFlag(enabled) {
  return enabled ? { applePay: 'auto', googlePay: 'auto' } : WALLETS_NEVER;
}
